import React from "react";
import MinhaEmpresaCard from "./Dashboard/MinhaEmpresaCard";
import ContasPendentesCard from "./Dashboard/ContasPendentesCard";
import DashboardSmallCards from "./Dashboard/DashboardSmallCards";
import FaturamentoGrafico from "./Dashboard/FaturamentoGrafico";
import useApi from "../../hooks/useApi";
import DashboardApiClient from "../../api/dashboard";
import { AppContext } from "../../contexts/AppContext";
import CommonSwal from "../../components/Swal/commonSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import ErrorSwal from "../../components/Swal/errorSwal";

function Dashboard() {
  const [tabelaDados, setTabelaDados] = React.useState([]);
  const [dashboardDados, setDashboardDados] = React.useState({});
  const [alertas, setAlertas] = React.useState(null);
  const { session, baseUrl } = React.useContext(AppContext);

  const { request: getDadosTabela, data: responseDadosTabela } = useApi(
    DashboardApiClient.getTabela
  );
  const { request: getDashboard, data: responseDashboard } = useApi(
    DashboardApiClient.getDashboard
  );
  const { request: getInadimplente } = useApi(
    DashboardApiClient.getInadimplente
  );
  const { request: getAlertas, data: responseAlertas } = useApi(
    DashboardApiClient.getAlertas
  );
  const alterFirstLoginApi = useApi(DashboardApiClient.alterFirstLogin);
  const checkEmailApi = useApi(DashboardApiClient.checkEmail);
  const sendFaturamentoMessageApi = useApi(
    DashboardApiClient.sendFaturamentoMessage
  );

  //Busca dados do gráfico ao renderizar tela
  React.useEffect(() => {
    getDadosTabela();
  }, [getDadosTabela]);

  //Busca dados do dashboard ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getDashboard(session.empresa.replace(/E/gi, ""));
  }, [getDashboard, session.empresa]);

  //Busca dados dos alertas ao renderizar tela
  React.useEffect(() => {
    if (session.empresa && session.user_guid)
      getAlertas(session.empresa.replace(/E/gi, ""), session.user_guid);
  }, [getAlertas, session.empresa, session.user_guid]);

  //Define o retorno do backend nos valores do gráfico
  React.useEffect(() => {
    if (!responseDadosTabela) return;
    const series = tratarDadosTabela(
      JSON.parse(responseDadosTabela.data.grafico ?? "")
    );
    setTabelaDados(series);
  }, [responseDadosTabela]);

  //Define o retorno da api nos valores do dashboard
  React.useEffect(() => {
    if (responseDashboard) setDashboardDados(responseDashboard);
  }, [responseDashboard]);

  //Define o retorno da api no estado dos alertas
  React.useEffect(() => {
    if (responseAlertas) setAlertas(responseAlertas);
  }, [responseAlertas]);

  //Roda alertas após o retorno da api
  React.useEffect(() => {
    if (alertas && Object.keys(alertas).length > 0) verificarAlertas(alertas);
  }, [alertas]); // eslint-disable-line react-hooks/exhaustive-deps

  const tratarDadosTabela = (dados) => {
    var series = [];
    var dadosPorAno = {};

    if (dados && dados.faturamento) {
      for (var dado of dados.faturamento) {
        var ano = dado.ano;
        if (!dadosPorAno[ano]) {
          dadosPorAno[ano] = Array(12).fill(0);
        }

        var mes = parseInt(dado.mes) - 1;
        var valorComercio = parseFloat(dado.valor_comercio);
        var valorServico = parseFloat(dado.valor_servico);
        var totalFaturamento = valorComercio + valorServico;

        dadosPorAno[ano][mes] += totalFaturamento;
      }
    }

    if (dados && dados.infoNotas) {
      for (var nota of dados.infoNotas.notas) {
        var anoNota = nota.ano;
        if (!dadosPorAno[anoNota]) {
          dadosPorAno[anoNota] = Array(12).fill(0);
        }

        var mesNota = parseInt(nota.mes) - 1;
        var valorNota = parseFloat(nota.valor);

        dadosPorAno[anoNota][mesNota] += valorNota;
      }
    }

    for (var dadosAno in dadosPorAno) {
      var serieData = {
        name: dadosAno,
        data: dadosPorAno[dadosAno],
      };

      series.push(serieData);
    }

    return series;
  };

  const faturamentoMeiAlert = (tipoEmpresa, valor) => {
    return new Promise((resolve) => {
      if (parseInt(tipoEmpresa) === 1) {
        if (valor > 100) {
          CommonSwal({
            icon: "error",
            title:
              "Atenção! Seu faturamento ultrapassou o limite máximo permitido.",
            text: "Para sua segurança, suspenderemos temporariamente a emissão de notas fiscais. Por favor, entre em contato com nosso suporte para resolver essa situação o mais rápido possível.",
          }).then(async (result) => {
            if (result.isConfirmed || result.isDismissed) {
              await sendFaturamentoMessageApi.request(
                session.empresa.replace(/E/gi, ""),
                session.user_guid,
                {
                  valor: valor,
                  bloqueio: 1,
                  alert: 100,
                }
              );
              resolve();
            }
          });
        } else if (valor > 90) {
          CommonSwal({
            icon: "error",
            title:
              "Atenção! Seu faturamento está quase atingindo o limite máximo permitido.",
            text: "Para sua segurança, suspenderemos temporariamente a emissão de notas fiscais. Por favor, entre em contato com nosso suporte.",
          }).then(async (result) => {
            if (result.isConfirmed || result.isDismissed) {
              await sendFaturamentoMessageApi.request(
                session.empresa.replace(/E/gi, ""),
                session.user_guid,
                {
                  valor: valor,
                  bloqueio: 1,
                  alert: 90,
                }
              );
              resolve();
            }
          });
        }
      } else resolve();
    });
  };

  const alertaEmail = () => {
    return new Promise((resolve, reject) => {
      var email, confirmEmail;
      OptionsSwal({
        confirmButtonText: "Alterar",
        denyButtonText: "Cancelar",
        progressSteps: [1, 2],
        currentProgressStep: 0,
        title: "Novo e-mail",
        input: "email",
        validationMessage: "E-mail inválido",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          email = result.value;
          OptionsSwal({
            confirmButtonText: "Alterar",
            denyButtonText: "Cancelar",
            progressSteps: [1, 2],
            currentProgressStep: 1,
            title: "Repita o e-mail",
            input: "email",
            validationMessage: "E-mail inválido",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              confirmEmail = result.value;
              resolve({ email, confirmEmail });
            }
            if (result.isDenied) {
              reject();
            }
          });
        }
        if (result.isDenied) {
          reject();
        }
      });
    });
  };

  const alteraEmail = () => {
    return new Promise((resolve) => {
      alertaEmail()
        .then(async ({ email, confirmEmail }) => {
          if (email !== confirmEmail) {
            await ErrorSwal({
              title: "Os e-mails devem ser iguais",
            }).then(async (result) => {
              if (result.isConfirmed || result.isDismissed) {
                await alteraEmail();
              }
            });
          } else {
            await checkEmailApi.request(session.empresa.replace(/E/gi, ""), {
              uid: session.user_guid,
              email: email,
            });
            resolve();
          }
        })
        .catch(() => {
          checkEmail(1);
        });
    });
  };

  const checkEmail = (checkEmail) => {
    return new Promise((resolve) => {
      if (parseInt(checkEmail) === 1) {
        OptionsSwal({
          title: "Favor, confirme o seu e-mail de acesso à plataforma",
          text: "E-mail atual: " + session?.email,
          imageUrl:
            "https://orangiuz.com.br/wp-content/uploads/2022/09/temp.svg",
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: "Custom image",
          denyButtonColor: "#50a5f1",
          confirmButtonText: "Alterar e-mail",
          denyButtonText: "Confirmar e-mail",
          reverseButtons: true,
          allowOutsideClick: false,
          width: 600,
        }).then(async (result) => {
          if (result.isConfirmed) {
            await alteraEmail();
            resolve();
          }
          if (result.isDenied) {
            await checkEmailApi.request(session.empresa.replace(/E/gi, ""), {
              uid: session.user_guid,
              email: session.email,
            });
            resolve();
          }
        });
      } else resolve();
    });
  };

  const alterPassword = (firstLogin) => {
    return new Promise((resolve) => {
      if (parseInt(firstLogin) === 1) {
        OptionsSwal({
          title: "Bem-vindo à nossa plataforma!",
          text: "Por medida de segurança recomendamos que altere sua senha.",
          imageUrl:
            "https://orangiuz.com.br/wp-content/uploads/2022/09/temp.svg",
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: "Custom image",
          confirmButtonText: "Redefinir senha",
          denyButtonText: "Cancelar",
          reverseButtons: true,
          allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            document.getElementById("bntAlterPassword").click();
            await alterFirstLoginApi.request(
              session.empresa.replace(/E/gi, ""),
              { uid: session.user_guid }
            );
            resolve();
          }

          if (result.isDenied) {
            await alterFirstLoginApi.request(
              session.empresa.replace(/E/gi, ""),
              { uid: session.user_guid }
            );
            resolve();
          }
        });
      } else resolve();
    });
  };

  const alertInadimplente = () => {
    return new Promise((resolve, reject) => {
      getInadimplente()
        .then(async (response) => {
          if (!response) return reject();
          if (parseInt(response.inadiplente) === 1) {
            await CommonSwal({
              title:
                "Atenção: Você possui mensalidades em atraso. Realize o pagamento agora para evitar bloqueios no serviço e na plataforma.",
              icon: "warning",
              confirmButtonColor: "#34c38f",
              confirmButtonText: "Regularizar débitos",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href =
                  baseUrl +
                  "contabilidade/contasAPagar/ContasAPagar?tab=honorarios";
                resolve();
              } else {
                resolve();
              }
            });
          } else {
            resolve();
          }
        })
        .catch(reject);
    });
  };

  const verificarAlertas = async (alertas) => {
    await faturamentoMeiAlert(alertas?.tipoEmpresa, alertas?.valor);
    await checkEmail(alertas?.checkEmail);
    await alterPassword(alertas?.firstLogin);
    await alertInadimplente();
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-4">
          <MinhaEmpresaCard />
          <ContasPendentesCard dashboardDados={dashboardDados} />
        </div>
        <div className="col-xl-8">
          <DashboardSmallCards dashboardDados={dashboardDados} />
          <FaturamentoGrafico tabelaDados={tabelaDados} />
        </div>
      </div>
    </>
  );
}

export default Dashboard;
